var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1 5h4V1M19 15h-4v4M5 5v8a2 2 0 0 0 2 2h8M7.5 5H13a2 2 0 0 1 2 2v5.5","stroke":"var(--v-primary-base)","stroke-width":"1.5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }